<template>
    <z-list-item
        :class="[
            'z-filelist-item',
            { 'z-filelist-item--with-icon': icon }
        ]"
    >
        <div
            :class="[
                'z-filelist-item__body',
                { 'z-filelist-item__body--center': center }
            ]"
        >
            <div class="z-filelist-item__icon">
                <z-icon
                    v-show="icon"
                    :name="icon"
                    :width="width"
                    :height="height"
                />
            </div>
            <div class="z-filelist-item__slot">
                <slot />
                <div class="z-filelist-item__info">
                    <span
                        v-show="info"
                        v-html="info"
                    ></span>
                    <span
                        v-show="date"
                    >{{ date | momentFilter('DD.MM.YYYY') }}</span>
                </div>
            </div>
        </div>
    </z-list-item>
</template>

<script>
export default {
    name: 'z-filelist-item',
    props: {
        icon: {
            type: String,
            default: ''
        },
        width: {
            type: String,
            default: '32'
        },
        height: {
            type: String,
            default: '32'
        },
        info: {
            type: String,
            default: ''
        },
        date: {
            type: [String, Number],
            default: ''
        },
        center: Boolean
    }
}
</script>
